import React from 'react';

import {Helmet} from 'react-helmet';
import {connect} from 'react-redux';

import {fetchUserProfile, updateUserProfile} from '../../ducks/user';
import {openModal} from '../../ducks/ui';
import {asMappedSubmissionError} from '../../utils/asSubmissionError';

import Loader from '../../components/loader/Loader';
import Breadcrumbs from '../../components/breadcrumbs/Breadcrumbs';
import ProfileForm from '../../components/profile/ProfileForm';
import CategoryMenuProfile from '../../components/categoryMenu/CategoryMenuProfile';
import ChangePasswordModal from '../auth/modals/ChangePasswordModal';
import {injectIntl} from 'react-intl';
import {analyticsProfileUpdated} from '../../middlewares/analytics/actions';

@injectIntl
@connect(({user}) => ({profile: user.profile}))
export default class ProfileGeneral extends React.PureComponent {
  static fetchData = ({dispatch, profile}) => profile === undefined && dispatch(fetchUserProfile());

  updateProfile = ({avatar, email, ...profile}) => {
    const {dispatch} = this.props;

    if (avatar) {
      avatar = avatar[0];
    }

    return this.props.dispatch(updateUserProfile(profile, avatar))
      .catch(asMappedSubmissionError({'user.username': 'username', 'avatar.file': 'avatar'}))
      .then(dispatch(analyticsProfileUpdated(profile)));
  };

  componentDidMount() {
    ProfileGeneral.fetchData(this.props);
  }

  componentDidUpdate() {
    ProfileGeneral.fetchData(this.props);
  }

  render() {
    const {intl, dispatch, profile} = this.props;

    if (!profile) {
      return <Loader page/>;
    }

    return (
      <div className="page-profile">
        <Helmet>
          <title>{intl.formatMessage({id: 'section.profile.my-profile'})}</title>
        </Helmet>

        <Breadcrumbs links={[{name: intl.formatMessage({id: 'section.profile.user-profile'})}]}/>

        <CategoryMenuProfile title={intl.formatMessage({id: 'section.profile.user-profile'})}/>

        <h1>{intl.formatMessage({id: 'section.profile.user-profile'})}</h1>

        <ProfileForm
          currentAvatar={profile.images[0]}
          initialValues={{
            username: profile.username,
            email: profile.email,
            skypeUsername: profile.skypeUsername || '',
            discordUsername: profile.discordUsername || '',
            phoneNumber: ''
          }}
          onSubmit={this.updateProfile}
          onPasswordReset={() => dispatch(openModal(ChangePasswordModal))}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/profilePage/ProfileGeneral.js